<p-tabView [(activeIndex)]="selectedTabIndex">
    <p-tabPanel header="Question Groups">
        <app-questionnaire-groups [displayGroupAdd]="displayGroupAdd" (closeDialog)="closeGroupAddDialog()"></app-questionnaire-groups>
    </p-tabPanel>
    <p-tabPanel header="Questions">
        <app-questionnaire-questions [displayQuestionAdd]="displayQuestionAdd" (closeDialog)="closeQuestionAddDialog()"></app-questionnaire-questions>
    </p-tabPanel>
    <p-tabPanel header="Activity Types">
        <p-table [value]="visitTypes">
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th>Last Updated</th>
                    <th>Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-typeDetails let-i="rowIndex">
                <tr>
                    <td>{{typeDetails.name}}</td>
                    <td>{{typeDetails.updatedDate | localDate: 'MM/DD/YYYY'}}</td>
                    <td class="action">
                        <span class="btnBars p-mr-0" (click)="editVisitType(typeDetails)" pTooltip="Edit"
                            tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-tabPanel>
    <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
        <ng-template pTemplate="header">
          <p-menu #configmenuQuestionnaire id="config_menu_questionnaire" [model]="configMenuQuestionnaireItems"
            [popup]="true" appendTo="body"></p-menu>
          <span class="btnBars p-mr-0" (click)="configmenuQuestionnaire.toggle($event)">
            <i class="pi pi-bars"></i>
          </span>
        </ng-template>
    </p-tabPanel>
</p-tabView>

<p-dialog header="{{visitDialogHeader}}" [(visible)]="displayVisitAddEdit" [style]="{width: '50vw'}">
    <div class="p-grid">
        <div class="p-col-12">
            <label for="name">Name <span style="color: red;">*</span></label>
            <input type="text" pInputText [(ngModel)]="selectedVisitDetails.name">
        </div>
        <div class="p-col-12">
            <label for="name">Description</label>
            <input type="text" pInputText style="width: 100%;" [(ngModel)]="selectedVisitDetails.description">
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton (click)="closeVisitAddEdit()" label="Cancel" class="p-button-secondary"></button>
        <button pButton [disabled]="!selectedVisitDetails.name.trim()" (click)="saveVisitType()" label="Save"></button>
    </ng-template>
</p-dialog>
